import { EChartPeriod } from '@aqx-core/common/api/chart';
import { TTVPeriod } from '@aqx-core/common/services/trade/analysis/equity-chart/types/tv-set-initial-configs';
import { EChartTopicPeriod } from '@aqx-core/common/socket/topics/chart';

export const getMinutesFromMonth = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  return daysInMonth * 24 * 60;
};

export const mapChartPeriodToTopicPeriod = (period: EChartPeriod): EChartTopicPeriod => {
  const chartToTopicMap: Record<EChartPeriod, EChartTopicPeriod> = {
    [EChartPeriod.PERIOD_M1]: EChartTopicPeriod.MINUTE_1,
    [EChartPeriod.PERIOD_M2]: EChartTopicPeriod.MINUTE_2,
    [EChartPeriod.PERIOD_M3]: EChartTopicPeriod.MINUTE_3,
    [EChartPeriod.PERIOD_M4]: EChartTopicPeriod.MINUTE_4,
    [EChartPeriod.PERIOD_M5]: EChartTopicPeriod.MINUTE_5,
    [EChartPeriod.PERIOD_M6]: EChartTopicPeriod.MINUTE_6,
    [EChartPeriod.PERIOD_M10]: EChartTopicPeriod.MINUTE_10,
    [EChartPeriod.PERIOD_M15]: EChartTopicPeriod.MINUTE_15,
    [EChartPeriod.PERIOD_M20]: EChartTopicPeriod.MINUTE_20,
    [EChartPeriod.PERIOD_M30]: EChartTopicPeriod.MINUTE_30,
    [EChartPeriod.PERIOD_H1]: EChartTopicPeriod.HOUR_1,
    [EChartPeriod.PERIOD_H2]: EChartTopicPeriod.HOUR_2,
    [EChartPeriod.PERIOD_H3]: EChartTopicPeriod.HOUR_3,
    [EChartPeriod.PERIOD_H4]: EChartTopicPeriod.HOUR_4,
    [EChartPeriod.PERIOD_H6]: EChartTopicPeriod.HOUR_6,
    [EChartPeriod.PERIOD_H8]: EChartTopicPeriod.HOUR_8,
    [EChartPeriod.PERIOD_H12]: EChartTopicPeriod.HOUR_12,
    [EChartPeriod.PERIOD_D1]: EChartTopicPeriod.DAY,
    [EChartPeriod.PERIOD_W1]: EChartTopicPeriod.WEEK,
    [EChartPeriod.PERIOD_MN1]: EChartTopicPeriod.MONTH
  };

  return chartToTopicMap[period] || EChartTopicPeriod.MINUTE_1;
};

export const periodToSeconds = (period: EChartPeriod): number => {
  const secondsPerMin = 60;
  const minutesPerHour = 60;
  const minutesPerDay = 24 * minutesPerHour;

  const periodToMinutes: Record<EChartPeriod, number> = {
    [EChartPeriod.PERIOD_M1]: 1,
    [EChartPeriod.PERIOD_M2]: 2,
    [EChartPeriod.PERIOD_M3]: 3,
    [EChartPeriod.PERIOD_M4]: 4,
    [EChartPeriod.PERIOD_M5]: 5,
    [EChartPeriod.PERIOD_M6]: 6,
    [EChartPeriod.PERIOD_M10]: 10,
    [EChartPeriod.PERIOD_M15]: 15,
    [EChartPeriod.PERIOD_M20]: 20,
    [EChartPeriod.PERIOD_M30]: 30,
    [EChartPeriod.PERIOD_H1]: minutesPerHour,
    [EChartPeriod.PERIOD_H2]: 2 * minutesPerHour,
    [EChartPeriod.PERIOD_H3]: 3 * minutesPerHour,
    [EChartPeriod.PERIOD_H4]: 4 * minutesPerHour,
    [EChartPeriod.PERIOD_H6]: 6 * minutesPerHour,
    [EChartPeriod.PERIOD_H8]: 8 * minutesPerHour,
    [EChartPeriod.PERIOD_H12]: 12 * minutesPerHour,
    [EChartPeriod.PERIOD_D1]: minutesPerDay,
    [EChartPeriod.PERIOD_W1]: 7 * minutesPerDay,
    [EChartPeriod.PERIOD_MN1]: getMinutesFromMonth()
  };

  return (periodToMinutes[period] || 1) * secondsPerMin;
};

export const chartPeriodToTVPeriod = (period: EChartPeriod): TTVPeriod => {
  const chartPeriodToTVMap: Record<EChartPeriod, TTVPeriod> = {
    [EChartPeriod.PERIOD_M1]: 'PERIOD_M1',
    [EChartPeriod.PERIOD_M2]: 'PERIOD_M2',
    [EChartPeriod.PERIOD_M3]: 'PERIOD_M3',
    [EChartPeriod.PERIOD_M4]: 'PERIOD_M4',
    [EChartPeriod.PERIOD_M5]: 'PERIOD_M5',
    [EChartPeriod.PERIOD_M6]: 'PERIOD_M6',
    [EChartPeriod.PERIOD_M10]: 'PERIOD_M10',
    [EChartPeriod.PERIOD_M15]: 'PERIOD_M15',
    [EChartPeriod.PERIOD_M20]: 'PERIOD_M20',
    [EChartPeriod.PERIOD_M30]: 'PERIOD_M30',
    [EChartPeriod.PERIOD_H1]: 'PERIOD_H1',
    [EChartPeriod.PERIOD_H2]: 'PERIOD_H2',
    [EChartPeriod.PERIOD_H3]: 'PERIOD_H3',
    [EChartPeriod.PERIOD_H4]: 'PERIOD_H4',
    [EChartPeriod.PERIOD_H6]: 'PERIOD_H6',
    [EChartPeriod.PERIOD_H8]: 'PERIOD_H8',
    [EChartPeriod.PERIOD_H12]: 'PERIOD_H12',
    [EChartPeriod.PERIOD_D1]: 'PERIOD_D1',
    [EChartPeriod.PERIOD_W1]: 'PERIOD_W1',
    [EChartPeriod.PERIOD_MN1]: 'PERIOD_MN1'
  };

  return chartPeriodToTVMap[period] || 'PERIOD_H1';
};
